import React from 'react';
import Joyride from 'react-joyride';

interface ReactJoyrideProps {
  steps: any;
  run: boolean;
  scrollOffset?: number;
  callback: (data: any) => void;
}

const ReactJoyride: React.FC<ReactJoyrideProps> = (props) => {
  const { steps, scrollOffset, run, callback } = props;

  return (
    <Joyride
      steps={steps}
      scrollOffset={scrollOffset}
      styles={{
        options: {
          zIndex: 1000,
        },
        buttonNext: {
          backgroundColor: '#0365bf',
          fontSize: 14,
        },
        buttonSkip: {
          color: '#A8A8A8',
        },
        tooltip: {
          textAlign: 'left',
        },
        tooltipTitle: {
          textAlign: 'left',
          fontSize: 16,
        },
        tooltipContent: {
          textAlign: 'left',
          fontSize: 16,
        },
        buttonBack: {
          color: '#A8A8A8',
        },
        buttonClose: {
          color: '#A8A8A8',
        },
      }}
      showProgress
      run={run}
      continuous={true}
      showSkipButton={true}
      disableOverlayClose={true}
      hideCloseButton
      callback={callback}
      locale={{
        // 新增：自定义按钮文本
        next: '下一步',
        back: '上一步',
        close: '关闭',
        last: '知道了',
        skip: '不再提示',
        nextLabelWithProgress: '下一步 ({step}/{steps})',
      }}
    />
  );
};

export default ReactJoyride;
